
import React from "react";
import { Button, Col, Row, Modal, Spinner } from "react-bootstrap";
import { Button as ButtonMaterial } from "@mui/material";
import { Card, CardBody, CardHeader, Input, Label } from "reactstrap";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import Autocomplete from '@mui/material/Autocomplete';
import { TextField } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import MUIDataTable from "mui-datatables"
import { MDBBadge } from 'mdb-react-ui-kit';
import 'react-loading-skeleton/dist/skeleton.css'
import RiskManagementGtPointMap from "./RiskManagementGtPointMap";
import RiskManagementGtPointDetailViewLatLongMap from "./RiskManagementGtPointDetailViewLatLongMap";
import { useGetCropListLangQuery, useGetGtPointSurveyQuery } from "./RiskManagementApiSlice";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
import Tooltip from "@mui/material/Tooltip";
import { store } from 'app/store'
import { API_URL } from 'app/config'
import RiskManagementGtPointDetailViewPolygonMap from "./RiskManagementGtPointDetailViewPolygonMap";
import RiskManagementGtPointCreateBoundary from "./RiskManagementGtPointCreateBoundary";
import { useGtSaathiAprrovalbyIdMutation, useGtPointCreateBoundaryMutation } from "./RiskManagementApiSlice";
import swal from "sweetalert"
import { useSelector } from "react-redux";
import { selectCurrentUser } from "features/auth/authSlice";
import { DateRangePicker } from 'rsuite';
import "rsuite/dist/rsuite.css"
import moment from 'moment';
import Paper from '@mui/material/Paper';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';
import DownloadIcon from '@mui/icons-material/Download';
import CancelIcon from '@mui/icons-material/Cancel';
import { selectLanguage } from "features/auth/authSlice";
import { useTranslation } from "react-i18next";

const NoEditingGtPoint = ({ cardName,RoleAcessParams,cropdata,refetch,handleClose,cropdataLatLong,cropdataFertilizer,cropdataIrrigation }) => {
     const [openLightbox, setOpenLightBox] = useState(false);
      const [lightBoxViewImage, setImageInLightbox] = useState("");
    const handleLightBoxImage = (image) => {
        setImageInLightbox(image);
        setOpenLightBox(true);
      };

  return (
    <>
     
          <Modal.Body>
            <Row><Col lg="1"></Col>
              <div className="">
           


                  <>
                    
                                             <Row className="">
                     
                                             
                     
                                               <Col lg="3" className="mb-2">
                                                 <Label>Farmer Name</Label>
                                                 <Input
                                                   type="text"
                                                   name="FarmerName"
                                                   className="f400"
                                                   disabled
                                                   id=""
                                                   defaultValue={
                                                     cropdata?.FarmerName}
                                                 />
                                               </Col>  <Col lg="3" className="mb-2">
                                                 <Label>Farmer Phone No</Label>
                                                 <Input
                                                   type="text"
                                                   name="FarmerMobile"
                                                   className="f400"
                                                   disabled
                                                   id=""
                                                   defaultValue={
                                                     cropdata?.FarmerMobile}
                                                 />
                                               </Col>  <Col lg="3" className="mb-2">
                                                 <Label>Lat/Long</Label>
                                                 <Input
                                                   type="text"
                                                   name="CropName"
                                                   className="f400"
                                                   disabled
                                                   id=""
                                                   defaultValue={
                                                     cropdataLatLong.length > 0 ? (cropdataLatLong[0].lat).toFixed(4) + "/" + (cropdataLatLong[0].long).toFixed(4) : ""}
                                                 />
                                               </Col>
                                               <Col lg="3" className="mb-2">
                                                 <Label>Crop Name</Label>
                                                 <Input
                                                   type="text"
                                                   name="CropName"
                                                   className="f400"
                                                   disabled={true}
                                                   id=""
                                                   defaultValue={
                                                     cropdata?.CropName}
                                                 />
                                               </Col>
                                               <Col lg="3" className="mb-2">
                                                 <Label>Crop Variety</Label>
                                                 <Input
                                                   type="text"
                                                   name="CropVariety"
                                                   id=""
                                                   defaultValue={cropdata?.CropVariety}
                                                   className="f400"
                                                   disabled={true}
                                                 />
                                               </Col>
                                               <Col lg="3" className="mb-3">
                                                 <Label>Crop Stage</Label>
                                                 <Input
                                                   type="text"
                                                   name="StressReason"
                                                   id=""
                                                   defaultValue={cropdata?.CropStage}
                                                   className="f400"
                                                   disabled
                                                 />
                                               </Col>
                                               <Col lg="3" className="mb-2">
                                                 <Label>Pesticide Name</Label>
                                                 <Input
                                                   type="text"
                                                   name="PestiscideName"
                                                   id=""
                                                   defaultValue={cropdata?.PestiscideName}
                                                   className="f400"
                                                   disabled={true}
                                                 />
                                               </Col>
                                               <Col lg="3" className="mb-3">
                                                 <Label>Soil Moisture</Label>
                                                 <Input
                                                   type="text"
                                                   name="VarietyName"
                                                   id=""
                                                   defaultValue={cropdata?.SoilMoisture}
                                                   className="f400"
                                                   disabled
                                                 />
                                               </Col>
                                               <Col lg="3" className="mb-3">
                                                 <Label>Sowing Date</Label>
                                                 <Input
                                                   type="text"
                                                   name="IsIrrigated"
                                                   id=""
                                                   defaultValue={cropdata?.SowingDate}
                                                   className="f400"
                                                   disabled
                                                 />
                                               </Col>
                                               <Col lg="3" className="mb-3">
                                                 <Label>Remarks</Label>
                                                 <Input
                                                   type="text"
                                                   name="Remarks"
                                                   id=""
                                                   defaultValue={cropdata?.OtherRemark}
                                                   className="f400"
                                                   disabled
                                                 />
                                               </Col>
                                               <Col lg="3" className="mb-3">
                                                 <Label>Last Year Yield</Label>
                                                 <Input
                                                   type="text"
                                                   name="IrrigationCount"
                                                   id=""
                                                   defaultValue={cropdata?.LastYearYield}
                                                   className="f400"
                                                   disabled
                                                 />
                                               </Col>
                     
                                               <Col lg="3" className="mb-3">
                                                 <Label>Is Disease Attack</Label>
                                                 <Input
                                                   type="text"
                                                   name="IsPestiscide"
                                                   id=""
                                                   defaultValue={cropdata?.IsDiseaseAndPestAttack?"Yes":"No"}
                                                   className="f400"
                                                   disabled
                                                 />
                                               </Col>
                     
                                               <Col lg="3" className="mb-3">
                                                 <Label>Is Irrigated</Label>
                                                 <Input
                                                   type="text"
                                                   name="AnyStress"
                                                   id=""
                                                   defaultValue={cropdata?.IsIrrigated?"Yes":"No"}
                                                   className="f400"
                                                   disabled
                                                 />
                                               </Col>
                                               <Col lg="3" className="mb-3">
                                                 <Label>Irrigation Source</Label>
                                                 <Input
                                                   type="text"
                                                   name="StressReason"
                                                   id=""
                                                   defaultValue={cropdata?.IrrigationSource}
                                                   className="f400"
                                                   disabled
                                                 />
                                               </Col>
                     
                     
                                               <Col lg="3" className="mb-3">
                                                 <Label>Fertilizer Type</Label>
                                                 <Input
                                                   type="text"
                                                   name="StressReason"
                                                   id=""
                                                   defaultValue={cropdata?.FertilizerType}
                                                   className="f400"
                                                   disabled
                                                 />
                                               </Col>
                     
                                             </Row>
                                             {cropdataFertilizer.length > 0 ?
                                               <>
                                                 <h5 className="my-3 p-3 bg-secondary3">Fertilizers </h5>
                                                 <Row>
                                                   <Col lg="3" className="mb-3">
                                                     <Label>&nbsp;Name</Label></Col>
                                                   <Col lg="3" className="mb-3">
                                                     <Label>&nbsp;Quantity</Label></Col>
                                                 </Row>
                                                 {cropdataFertilizer?.map((item) => {
                                                   return (
                                                     <Row>
                                                       <Col lg="3" className="mb-3">
                                                         <Input
                                                           type="text"
                                                           name="StressReason"
                                                           id=""
                                                           defaultValue={item?.name}
                                                           className="f400"
                                                           disabled
                                                         />
                                                       </Col>
                                                       <Col lg="3" className="mb-3">
                                                         <Input
                                                           type="text"
                                                           name="StressReason"
                                                           id=""
                                                           defaultValue={item?.quantity}
                                                           className="f400"
                                                           disabled
                                                         />
                                                       </Col>
                                                     </Row>
                                                   )
                                                 })}
                                               </>
                                               : ""}
                     
                                             <h5 className="my-3 p-3 bg-secondary3">Irrigation </h5>
                                             <Row>
                                               <div>&nbsp; Irrigation Count : <span className="text-success f400">{cropdata?.IrrigationCount}</span></div>
                                               {cropdataIrrigation?.length > 0 ?
                                                 <>
                                                   <div className="mt-3 "> &nbsp;&nbsp;Irrigation Value :</div>
                                                   <div className="d-flex mx-2">
                                                     {cropdataIrrigation?.map((item, index) => {
                                                       return (
                                                         <li className="mt-3 mx-4 f400  textlistHide">
                                                           <span className=" f400 text-black">{index + 1}<span class="mdi mdi-chevron-right"></span>
                                                           </span> <span className="text-success f400">{item?.name}</span>
                                                         </li>
                                                       )
                                                     })}
                                                   </div>
                                                 </>
                                                 : ""}
                                             </Row>
                                         
                
                              <Row>
                              <Card>
                              <CardHeader className="mt-2">Documents</CardHeader>
                              {cropdata ?
                                <Row>
                                  {
                                    cropdata?.Media ?
                                    cropdata?.Media?.map((list, index) =>
                                        list.ImagePath !== "" ? (
                                          <Col lg={3} key={list.index} className="mt-3"  >
                                            <Card className="text-center border ">
                                              <CardBody>
                                                <div className="img-fluid float-left">
                                                  <p className="mb-1 text-uppercase">{list.Attribute}</p>
                                                  <hr className="mt-2" />
                                                  {list.ImagePath.includes("mp4") ?
                                                    <video width="320" height="240" controls>
                                                      <source src={list.ImagePath} type="video/mp4" />
                                                      <source src={list.ImagePath} type="video/ogg" />
                                                    </video>
                                                    : list.ImagePath.includes("pdf") ?
                                                      <object data={list.ImagePath}
                                                        type='application/pdf'
                                                        width='100%'
                                                        height='400px' />
                                                      :
                                                      <img src={list.ImagePath}
                                                       onClick={()=>handleLightBoxImage(list.ImagePath)}
                                                        alt=""
                                                        className="img-fluid cursor-pointer"
                                                      />
                                                  }
                                                  <hr className="mt-2" />
                                                  <p className="mb-1 text-uppercase">Accuracy : {list.Metadata?list.Metadata.Accuracy:""}</p>
                                                  <p className="mb-1 text-uppercase">Azimuth : {list.Metadata?list.Metadata.azimuth:""}</p>
                                                  <p className="mb-1 text-uppercase">Elevation :{list.Metadata?list.Metadata.Elevation:""}</p>
                                                  
                                                  {openLightbox?
                                                    <Lightbox image={lightBoxViewImage} title="Image Title" onClose={() => setOpenLightBox(false)}/>
                                                  :""}
                                                </div>
                                              </CardBody>
                                            </Card>
                                          </Col>
                                        ) : null
                                      )
                                      : ""
                                  }
                  
                                </Row>
                                : null}
                                </Card>
                            </Row>
                           
                    <Row>
                      <Card className="mt-3">
                        <CardHeader className="mt-2">Boundary</CardHeader>
                        <CardBody>
                          {JSON.stringify(cropdata.FarmBoundaryVerified) !== `{}` ?
                            <RiskManagementGtPointDetailViewPolygonMap farmerBoundary={cropdata.FarmBoundaryVerified} MediaData="" />
                            : JSON.stringify(cropdata.FarmBoundaryVerified) === `{}` && JSON.stringify(cropdata.FarmBoundaryTagging) === `{}` ?
                              <RiskManagementGtPointDetailViewLatLongMap latLongData={cropdata.LatLong} />
                              : <RiskManagementGtPointDetailViewPolygonMap farmerBoundary={cropdata.FarmBoundaryTagging} MediaData={cropdata.Media} />
                          }
                        </CardBody>
                      </Card>
                    </Row>
                   
                  
                  </>
                 
              </div>
            </Row>
          </Modal.Body>
         

    </>
  );
};

export default NoEditingGtPoint;
